<template>
  <v-container  grid-list-xs>
    <v-row align="center" justify="center" class="mt-3">
      <v-col cols="12" xl="9" lg="9" class="text-justify">
        <v-row align="center" justify="center">
          <v-col cols="12" class="text-center">
            <h1> <p> Historia </p></h1>
          </v-col>
        </v-row>

        <h3> <p> En el año 1993 se llevó a cabo la 1era Olimpiada de Química en la Ciudad de México, participaron 757 estudiantes de 76
        planteles tanto de instrucción pública como privada, de la zona metropolitana del Valle de México. Debido al interés que despertó 
        y al éxito obtenido, en 1994 el concurso se llevó a cabo nuevamente y se denominó Olimpiada Metropolitana de Química, se conformó 
        una selección que participó en la I Olimpiada Nacional de Química.</p></h3>

        <h3><p> Año con año se busca incrementar el número de participantes, sin que decaiga el nivel académico, manteniendo nuestros objetivos
        de contribuir a un mejor conocimiento de los grandes beneficios que la química ha aportado a la humanidad; fomentar el interés por la 
        química de un mayor número de jóvenes, para así estimular su curiosidad científica y captarlos como futuros profesionales; promover el 
        incremento de la matrícula en las carreras del área de la química y del área científica en general; favorecer el intercambio de experiencias 
        docentes entre los profesores de nivel medio superior; fortalecer el enlace entre el nivel medio y superior. </p></h3>

        <h3><p>Para lograr esto siempre se ha contado con un grupo de trabajo con un alto sentido de responsabilidad y que ha trabajado en armonía. 
        Aparte de la Facultad de Química de la UNAM participan el CINVESTAV del IPN y el Departamento de Química de la UAM-Iztapalapa. La inclusión 
        de estas dos instituciones ha fortalecido la parte académica y de logística. Todo esto se ha apuntalado por el apoyo por parte de una de las 
        asociaciones más importantes de la industria química, la ANIQ, quienes nos apoyan desde el 2004.</p></h3>

      </v-col>
    </v-row>
  </v-container>  
</template>

<script>
export default {
  metaInfo: {
    title: 'Olimpiada de Quimica',
    titleTemplate: 'Historia - %s',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },
}
</script>

<style>

</style>